import React from 'react';
import { LocalizedLink } from 'src/components/common/LocalizedLink';

interface NavigationButtonProps {
  to: string;
  text: string;
  className?: string;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  to,
  text,
  className,
}) => {
  return (
    <LocalizedLink to={to} className={className}>
      {text}
    </LocalizedLink>
  );
};
